import { Link, usePage } from "@inertiajs/react"
import { Toaster } from "@/components/ui/sonner"
import { toast } from "sonner"
import { useEffect } from "react"

export default function Layout({ children }: { children: React.ReactNode }) {
  const { auth, flash } = usePage<{
    auth: { user: { id: number; username: string; admin: boolean } }
    flash: { notice?: string; alert?: string }
  }>().props

  useEffect(() => {
    if (flash.notice) {
      toast.success(flash.notice)
    }
    if (flash.alert) {
      toast.error(flash.alert)
    }
  }, [flash])

  return (
    <div className="min-h-screen bg-background font-sans antialiased">
      <header className="sticky top-0 z-40 w-full border-b bg-background">
        <div className="container flex h-16 items-center space-x-4 sm:justify-between sm:space-x-0">
          <div className="flex gap-6 md:gap-10">
            <Link href="/" className="flex items-center space-x-2">
              <span className="inline-block font-bold">Oligohelper</span>
            </Link>
            {auth.user && (
              <nav className="flex gap-6">
                <Link
                  href="/"
                  className="flex items-center text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
                >
                  Patients
                </Link>
                {auth.user.admin && (
                  <Link
                    href="/admin/users"
                    className="flex items-center text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
                  >
                    Admin
                  </Link>
                )}
              </nav>
            )}
          </div>
          <div className="flex flex-1 items-center justify-end space-x-4">
            <nav className="flex items-center space-x-1">
              {auth.user ? (
                <div className="flex items-center gap-4">
                  <span className="text-sm text-muted-foreground">
                    {auth.user.username}
                  </span>
                  <Link
                    href="/logout"
                    method="delete"
                    as="button"
                    className="text-sm font-medium text-muted-foreground transition-colors hover:text-destructive"
                  >
                    Déconnexion
                  </Link>
                </div>
              ) : (
                <Link
                  href="/login"
                  className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
                >
                  Connexion
                </Link>
              )}
            </nav>
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <Toaster />
    </div>
  )
}
